<template>
<div class="form-elements">
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget>
        <button class="btn btn-primary btn-micro" @click="changePassword"> {{'basic.button.apply' | translate}} </button>
      </vuestic-widget>
    </div>
  </div>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget :headerText="'profile.title' | translate">
        <form autocomplete="off">
          <input type="password" id="current-password" autocomplete="current-password" style="display:none" />
          <fieldset>
            <div class="va-row">
              <div class="flex md4">
                <div class="form-group">
                  <div class="input-group">
                    <input class="profile-input" id="user_name" v-model="user_name" disabled="true" />
                  </div>
                </div>
              </div>
              <div class="flex md4">
                <div class="form-group">
                  <div class="input-group">
                    <input class="profile-input" id="user_email" v-model="user_email" disabled="true" />
                  </div>
                </div>
              </div>
              <div class="flex md4">
                <div class="form-group">
                  <div class="input-group">
                    <input class="profile-input" id="user_role" v-model="user_role" disabled="true" />
                  </div>
                </div>
              </div>
              <div class="flex md4">
                <div class="form-group" style="margin-bottom: 0;">
                  <div class="input-group">
                    <input :type="isCurOpen?'text':'password'" :class="class_cpwd" id="cur_password" autocomplete="off" maxlength="50" v-model="cur_pwd" required onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')"  />
                    <label class="control-label" for="cur_password">{{'profile.cur_password' | translate}}</label><i class="bar"></i>
                    <div class="eye-password">
                      <img :src="closeEye" alt="" @click="() => { isCurOpen = true }" v-if="!isCurOpen"/>
                      <img :src="openEye" alt="" @click="() => { isCurOpen = false }" v-if="isCurOpen"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md4">
                <div class="form-group" style="margin-bottom: 0;">
                  <div class="input-group">
                    <input :type="isNewOpen?'text':'password'" :class="class_npwd" id="new_password" autocomplete="off" maxlength="50" v-model="new_pwd" required onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')"  />
                    <label class="control-label" for="new_password">{{'profile.new_password' | translate}}</label><i class="bar"></i>
                    <div class="eye-password">
                      <img :src="closeEye" alt="" @click="() => { isNewOpen = true }" v-if="!isNewOpen"/>
                      <img :src="openEye" alt="" @click="() => { isNewOpen = false }" v-if="isNewOpen"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md4">
                <div class="form-group" style="margin-bottom: 0;">
                  <div class="input-group">
                    <input :type="isRepOpen?'text':'password'" :class="class_rpwd" id="repeat_password" autocomplete="off" maxlength="50" v-model="rep_pwd" required onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')" />
                    <label class="control-label" for="repeat_password">{{'profile.repeat_password' | translate}}</label><i class="bar"></i>
                    <div class="eye-password">
                      <img :src="closeEye" alt="" @click="() => { isRepOpen = true }" v-if="!isRepOpen"/>
                      <img :src="openEye" alt="" @click="() => { isRepOpen = false }" v-if="isRepOpen"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group with-icon-right" style="margin-left:10px;">
                {{ $t('t.newPasswordMustBe') }}
              </div>
            </div>
          </fieldset>
        </form>
      </vuestic-widget>
    </div>
  </div>
</div>
</template>

<script>
import { request } from '@/utils/utils';
export default {
  data () {
    return {
      user_name: '',
      user_email: '',
      user_role: '',
      cur_pwd: '',
      new_pwd: '',
      rep_pwd: '',
      class_cpwd: '',
      class_npwd: '',
      class_rpwd: '',
      closeEye: require('@/assets/images/eye-close.png'),
      openEye: require('@/assets/images/eye-open.png'),
      isCurOpen: false,
      isNewOpen: false,
      isRepOpen: false,
    }
  },
  mounted () {
    this.initFormData()
  },
  methods: {
    changePassword () {
      this.class_cpwd = ''
      this.class_npwd = ''
      this.class_rpwd = ''
      // var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,18}$/;
      // 限制输入为大小写字母或者数字
      // var reg = /^(?=.*?[0-9])(?=.*?[a-z])[0-9a-z]{8,32}$/
      // if (!reg.test(this.new_pwd) || !reg.test(this.rep_pwd)) {
      //   // this.class_cpwd = 'error'
      //   this.class_npwd = 'error'
      //   this.class_rpwd = 'error'
      //   // alert('A senha deve ser uma combinação de letras minúsculas e números e deve ter de 8 a 32 caracteres.')
      //   alert('The password must be a combination of lowercase letters and numbers and must be between 8 and 32 characters long.')
      //   return;
      // }
      if (this.new_pwd != this.rep_pwd) {
        this.class_npwd = 'error'
        this.class_rpwd = 'error'
        alert('The new password does not match the repeated new password')
        return;
      }
      // 校验密码的复杂度
      let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
      if (!regExpPassword.test(this.new_pwd)) {
        alert(this.$t('t.newPasswordMustBe'))
        return;
      }

      let token = localStorage.getItem('Authorization')
      request({
        method: 'post',
        url: 'api/dashboard/app/user/changePassword?access_token=' + token,
        data: {
          old_password: this.cur_pwd,
          new_password: this.new_pwd
        }
      }).then(res => {
        if(res.data.code === "10000") {
          alert(res.data.msg)
          this.logout()
        } else {
          this.class_cpwd = 'error'
          if(res) {
            alert(res.data.msg)
          }
        }
      })
    },
    logout () {
      let token = localStorage.getItem('Authorization')
      request({
        method: 'delete',
        url: 'api/dashboard/logout?access_token=' + token,
      }).then(res => {
        console.log(res)
        this.$router.push({
          name: 'login',
        })
      })
    },
    initFormData () {
      this.cur_pwd = ''
      let token = localStorage.getItem('Authorization')
      request({
        method: 'post',
        url: 'api/dashboard/app/user/query?kyc=&access_token=' + token,
      }).then(res => {
        if (res.data.code != '10000') {
          return
        }
        let userInfo = res.data.data
        if (typeof (userInfo) !== 'undefined') {
          this.user_name = userInfo.username
          this.user_email = userInfo.email
          this.user_role = userInfo.role
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.profile-input {
    background: lightgray;
    border-radius: 2px;
}

.error {
    border-bottom-style: solid;
    border-bottom-width: medium;
    border-bottom-color: red;
}
.eye-password {
  position: absolute;
  top: 2px;
  right: 5px;
  width: 25px;
  cursor: pointer;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
